import _slicedToArray from "/src/main/react/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/images/ImageTable.js";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { Table, TableHead, TableBody, TableRow, TableCell, Grid, Typography, Button, LinearProgress, TextField, Tooltip, Fade, FormControl, Select, Input, MenuItem } from '@material-ui/core';
import Util, { statesDontMatch } from "../../util/Util";
import { ErrorTwoTone as Error } from '@material-ui/icons';
import { Dialog, Pagination, SimpleSnackbar } from "../common";
import { Controller, animated } from "react-spring";
import { ASPECT_RATIO, AUDIT_ACTION, AUDIT_STATUS, BASE_URIS, DATA_QUALITY_STATUS, ID_SPACE, IMAGETABLE_DESCRIPTIONS, LOCAL_STORAGE_ITEM_NAMES, PUBLISH_ACTION, PUBLISH_STATUS, TPIS_CAPABILITIES as CAPS, TPIS_PARAMS } from "../domain/constants";
import queryString from "query-string";
import { setUpPageInfoFromQueryString, determinePageSize } from "../../util/QueryStringUtil";
import PublishFailureTable from "./PublishFailureTable";
import { stringToList } from "../../util/StringUtil";
import { TPISRequestService } from "../../service";
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 0,
    overflowX: 'auto'
  },
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  },
  img: {
    display: 'block',
    maxWidth: '10vw',
    maxHeight: '30vh',
    width: 'auto',
    height: 'auto'
  },
  cell: {
    padding: 15,
    margin: 15
  },
  smallFont: {
    fontSize: 13
  },
  textField: {
    padding: 0,
    margin: 0,
    width: '100%'
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  },
  dqBadge: {
    color: 'red'
  }
});
class ImageTable extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", name => event => {
      // setState actually works for this one for whatever reason (forceUpdate doesn't)
      this.setState({
        [name]: event.target.value
      });
    });
    _defineProperty(this, "addAuditNotes", itemId => event => {
      const auditNotes = this.state.auditNotes;
      auditNotes[itemId] = event.target.value;
      this.forceUpdate();
    });
    _defineProperty(this, "determineAuditNotesDisabled", caps => {
      if (caps == null || caps === [] || caps === '') {
        return true;
      }
      if (caps.includes(CAPS.AUDIT) || caps.includes(CAPS.ADMIN)) {
        return false;
      }
      return true;
    });
    this.tpisRequestService = new TPISRequestService();
    const querystringValues = queryString.parse(this.props.location.search);
    const pageSize = determinePageSize(querystringValues, props);
    this.state = {
      description: props.description,
      baseUri: props.baseUri != null ? props.baseUri : null,
      images: null,
      existingImages: [],
      auditNotes: {},
      // never set this to null
      merlinId: props.merlinId,
      title: props.title,
      adiId: props.adiId,
      entityId: props.entityId,
      entityProvider: props.entityProvider,
      loaded: false,
      morePages: true,
      totalPages: 0,
      totalElements: 0,
      page: 0,
      pageSize: pageSize,
      forbidden: false,
      failures: null,
      ratio: ''
    };
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
    this.animations = new Controller({
      opacity: 0
    });
  }
  componentDidMount() {
    if (this.state.description != null && this.state.images == null) {
      this.loadContent();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    setUpPageInfoFromQueryString(this);
    if (statesDontMatch('merlinId', prevState, this.state) || statesDontMatch('title', prevState, this.state) || statesDontMatch('adiId', prevState, this.state) || statesDontMatch('entityId', prevState, this.state) || statesDontMatch('entityProvider', prevState, this.state) || statesDontMatch('page', prevState, this.state) || statesDontMatch('pageSize', prevState, this.state) || statesDontMatch('ratio', prevState, this.state) || statesDontMatch('description', prevState, this.state) || statesDontMatch('baseUri', prevState, this.state)) {
      this.loadContent();
    }
  }
  getActionButtons(image) {
    const _this$state = this.state,
      merlinId = _this$state.merlinId,
      adiId = _this$state.adiId,
      entityId = _this$state.entityId,
      description = _this$state.description;
    const self = this;
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    if (description !== IMAGETABLE_DESCRIPTIONS.legacy && description !== IMAGETABLE_DESCRIPTIONS.existing) {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justify: 'center',
        spacing: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 17
        }
      }, caps != null && Util.isVisibleForCapabilities(caps, [CAPS.READ]) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.state.failures = null;
          this.delete(image, merlinId, adiId, entityId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 25
        }
      }, "Delete")), caps != null && Util.isVisibleForCapabilities(caps, [CAPS.AUDIT]) && (image.publishStatus != null && image.publishStatus !== PUBLISH_STATUS.published || ImageTable.imageHasAuditableAssociations(image)) && description !== IMAGETABLE_DESCRIPTIONS.published && [/*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 172,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.audit(image, AUDIT_ACTION.accept, merlinId, adiId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 29
        }
      }, "Accept")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 177,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.audit(image, AUDIT_ACTION.reject, merlinId, adiId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178,
          columnNumber: 29
        }
      }, "Reject")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182,
          columnNumber: 25
        }
      }, image.auditStatus != null && image.auditStatus !== AUDIT_STATUS.pending && /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.audit(image, AUDIT_ACTION.retract, merlinId, adiId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184,
          columnNumber: 29
        }
      }, "Retract"))], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && (image.publishStatus != null && image.publishStatus !== PUBLISH_STATUS.published || ImageTable.imageHasPublishPendingOrFailedAssociations(image)) && image.auditStatus != null && image.auditStatus === AUDIT_STATUS.accepted && description !== IMAGETABLE_DESCRIPTIONS.rejected && description !== IMAGETABLE_DESCRIPTIONS.auditPending && [/*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.publish(image, PUBLISH_ACTION.publish, merlinId, adiId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 29
        }
      }, "Publish"))], caps != null && Util.isVisibleForCapabilities(caps, [CAPS.PUBLISH]) && image.publishStatus != null && image.publishStatus === PUBLISH_STATUS.published && [/*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 206,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: () => {
          this.publish(image, PUBLISH_ACTION.unpublish, merlinId, adiId, self);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 207,
          columnNumber: 29
        }
      }, "Unpublish"))]);
    } else {
      return /*#__PURE__*/React.createElement(Typography, {
        align: 'center',
        variant: 'subtitle',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 217,
          columnNumber: 17
        }
      }, "(Actions not available for legacy images)");
    }
  }

  /**
   * Load images for the current page
   * Resets this.state.images to an empty array each time
   */
  loadContent() {
    if (this.state.description === IMAGETABLE_DESCRIPTIONS.existing) {
      this.loadExistingImages();
    } else {
      this.state.loaded = false;
      this.state.forbidden = false;
      this.forceUpdate();
      const providerAndEntityId = ImageTable.determineProviderAndEntityId(this.state);
      const valid = this.validateProviderAndEntityId(providerAndEntityId);
      if (valid === false) {
        this.state.loaded = true;
        this.forceUpdate();
        return;
      }
      const query = ImageTable.makeUri(providerAndEntityId.provider, providerAndEntityId.entityId, this.state.title, this.state);
      if (query == null) {
        this.state.loaded = true;
        this.forceUpdate();
        return;
      }
      Util.fetchWithRedirect(query, 'GET', this.props).then(result => {
        if (result.status === 403) {
          this.state.forbidden = true;
          this.state.loaded = true;
          this.state.morePages = false;
          this.state.totalElements = 0;
          this.state.images = null;
          this.state.auditNotes = {};
        } else {
          const images = result.content;
          this.state.loaded = true;
          this.state.morePages = !result.last;
          this.state.totalPages = result.totalPages;
          this.state.totalElements = result.totalElements;
          this.state.images = images;

          // frontload auditNotes
          if (images != null) {
            for (let image of images) {
              if (image.auditDescription != null && image.auditDescription !== '') {
                this.state.auditNotes[image.id] = image.auditDescription;
              }
            }
          }
        }
        this.forceUpdate();
      }).catch(error => {
        Util.log('ImageTable.loadContent', true, error, false);
        this.setState({
          loaded: true
        });
      });
    }
  }
  validateProviderAndEntityId(providerAndEntityId) {
    if (providerAndEntityId.success === false && (this.state.title == null || this.state.title === '')) {
      // If all else fails, use the title. If there's no title, display an error to the user
      Util.createDialog('No ID provided', 'An ID and provider (or title) are required to view entities', this.dialogRef);
      console.warn('No id or title provided for /entity page');
      this.setState({
        loaded: true
      });
      return false;
    }
    return true;
  }
  loadExistingImages() {
    this.state.loaded = false;
    this.state.forbidden = false;
    this.state.existingImages = [];
    this.forceUpdate();
    const providerAndEntityId = ImageTable.determineProviderAndEntityId(this.state);
    const valid = this.validateProviderAndEntityId(providerAndEntityId);
    if (valid === false) {
      return;
    }
    this.tpisRequestService.listExistingImagesRequest(providerAndEntityId.entityId, this.state.page, this.state.pageSize, this.state.ratio, this).then(resp => {
      if (resp != null && resp.content != null) {
        for (let existingImage of resp.content) {
          this.state.existingImages.push(existingImage);
        }
        this.state.morePages = !resp.last;
        this.state.totalPages = resp.totalPages;
        this.state.totalElements = resp.totalElements;
      }
      this.state.loaded = true;
      this.forceUpdate();
    }).catch(error => {
      console.log(error.message);
      this.state.loaded = true;
      this.forceUpdate();
    });
  }
  render() {
    const classes = this.props.classes;
    const props = this.animations.update({
      opacity: 1
    });
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '40vh',
        minWidth: '80vw',
        marginTop: 0
      },
      className: classes.root,
      id: "table-eid-".concat(this.state.entityId),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 337,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 339,
        columnNumber: 17
      }
    }), this.state.description === IMAGETABLE_DESCRIPTIONS.existing && this.state.loaded && /*#__PURE__*/React.createElement(Grid, {
      md: 8,
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      wrap: 'nowrap',
      spacing: 1,
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 341,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 343,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 344,
        columnNumber: 25
      }
    }, "Ratio:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 346,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(FormControl, {
      className: classes.formControl,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 347,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Select, {
      id: "aspect-ratio-select",
      value: this.state.ratio,
      onChange: this.handleChange('ratio'),
      input: /*#__PURE__*/React.createElement(Input, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 350,
          columnNumber: 40
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 348,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: '',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 351,
        columnNumber: 33
      }
    }, "   "), Object.keys(ASPECT_RATIO).map(aspectRatio => /*#__PURE__*/React.createElement(MenuItem, {
      value: ASPECT_RATIO[aspectRatio],
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 353,
        columnNumber: 37
      }
    }, ASPECT_RATIO[aspectRatio])))))), /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 360,
        columnNumber: 17
      }
    }), Pagination(this.state, this, classes, true), /*#__PURE__*/React.createElement(PublishFailureTable, {
      id: JSON.stringify(this.state),
      key: JSON.stringify(this.state),
      failures: this.state.failures,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 362,
        columnNumber: 17
      }
    }), this.state.description !== IMAGETABLE_DESCRIPTIONS.existing && /*#__PURE__*/React.createElement(Table, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 366,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(TableHead, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 367,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 368,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 369,
        columnNumber: 29
      }
    }, "Image"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 370,
        columnNumber: 29
      }
    }, "Publish Status"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 371,
        columnNumber: 29
      }
    }, "Audit Status"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 372,
        columnNumber: 29
      }
    }, "Data Quality Status"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 373,
        columnNumber: 29
      }
    }, "Merlin Image ID"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 374,
        columnNumber: 29
      }
    }, "Image Type"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 375,
        columnNumber: 29
      }
    }, "Width"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 376,
        columnNumber: 29
      }
    }, "Height"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 377,
        columnNumber: 29
      }
    }, "Aspect Ratio"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 378,
        columnNumber: 29
      }
    }, "Format"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 379,
        columnNumber: 29
      }
    }, "Credit"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 380,
        columnNumber: 29
      }
    }, "Notes"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 381,
        columnNumber: 29
      }
    }, "Actions"))), /*#__PURE__*/React.createElement(TableBody, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 384,
        columnNumber: 21
      }
    }, this.state.loaded && this.state.images != null && this.state.images.map(image => /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 386,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 387,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: image.url,
      target: "_blank",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 388,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(animated.img, {
      src: image.url,
      alt: image.url,
      style: props,
      className: classes.img,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 389,
        columnNumber: 41
      }
    }))), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 393,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 0,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 394,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'column',
      alignItems: 'center',
      alignContent: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 396,
        columnNumber: 41
      }
    }, image.publishStatus ? image.publishStatus === PUBLISH_STATUS.failed ? [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 400,
        columnNumber: 57
      }
    }, image.publishStatus), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      justify: 'center',
      alignItems: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 403,
        columnNumber: 57
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      align: 'center',
      color: 'error',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 405,
        columnNumber: 61
      }
    }, image.publishDescription))] : image.publishStatus : '?'), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 413,
        columnNumber: 41
      }
    }, ImageTable.displayAnyAssociationPublishIssues(image, classes)))), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 418,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 0,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 419,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 421,
        columnNumber: 41
      }
    }, image.auditStatus ? image.auditStatus : '?'), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 424,
        columnNumber: 41
      }
    }, ImageTable.displayAnyAssociationAuditIssues(image, classes)))), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 429,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      spacing: 0,
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 430,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 432,
        columnNumber: 41
      }
    }, image.dataQualityStatus ? image.dataQualityStatus : 'N/A'), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 435,
        columnNumber: 41
      }
    }, ImageTable.displayAnyDataQualityIssues(image, classes)))), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 440,
        columnNumber: 33
      }
    }, image.merlinId ? image.merlinId : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 442,
        columnNumber: 33
      }
    }, image.imageType ? image.imageType : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 444,
        columnNumber: 33
      }
    }, image.width ? image.width : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 446,
        columnNumber: 33
      }
    }, image.height ? image.height : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 448,
        columnNumber: 33
      }
    }, image.aspectRatio ? image.aspectRatio : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 450,
        columnNumber: 33
      }
    }, image.format ? image.format : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 451,
        columnNumber: 33
      }
    }, image.photographer ? image.photographer : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      style: {
        margin: '0',
        padding: '0'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 453,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "outlined-multiline-static",
      multiline: true,
      rows: "4",
      value: this.state.auditNotes[image.id],
      placeholder: "Any notes to accompany audit decision (optional)",
      className: classes.textField,
      margin: "normal",
      variant: "outlined",
      onChange: this.addAuditNotes(image.id),
      disabled: this.determineAuditNotesDisabled(caps),
      InputProps: {
        classes: {
          input: classes.smallFont
        }
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 454,
        columnNumber: 37
      }
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 464,
        columnNumber: 33
      }
    }, this.getActionButtons(image)))))), this.state.description === IMAGETABLE_DESCRIPTIONS.existing && /*#__PURE__*/React.createElement(Table, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 471,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(TableHead, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 472,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 473,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 474,
        columnNumber: 29
      }
    }, "Image"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 475,
        columnNumber: 29
      }
    }, "Merlin Image ID"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 476,
        columnNumber: 29
      }
    }, "Feed Provider Type"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 477,
        columnNumber: 29
      }
    }, "Image Type"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 478,
        columnNumber: 29
      }
    }, "Date Added"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 479,
        columnNumber: 29
      }
    }, "Date Last Updated"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 480,
        columnNumber: 29
      }
    }, "Width"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 481,
        columnNumber: 29
      }
    }, "Height"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 482,
        columnNumber: 29
      }
    }, "Aspect Ratio"))), /*#__PURE__*/React.createElement(TableBody, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 485,
        columnNumber: 21
      }
    }, this.state.loaded && this.state.existingImages != null && this.state.existingImages.map(image => /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 487,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 488,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: image.url,
      target: "_blank",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 489,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(animated.img, {
      src: image.url,
      alt: image.url,
      style: props,
      className: classes.img,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 490,
        columnNumber: 41
      }
    }))), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 494,
        columnNumber: 33
      }
    }, image.merlinId ? image.merlinId : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 496,
        columnNumber: 33
      }
    }, image.feedProviderType ? image.feedProviderType : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 498,
        columnNumber: 33
      }
    }, image.imageType ? image.imageType : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 500,
        columnNumber: 33
      }
    }, image.added ? new Date(image.added).toUTCString() : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 502,
        columnNumber: 33
      }
    }, image.updated ? new Date(image.updated).toUTCString() : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 504,
        columnNumber: 33
      }
    }, image.width ? image.width : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 505,
        columnNumber: 33
      }
    }, image.height ? image.height : '?'), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      align: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 506,
        columnNumber: 33
      }
    }, image.aspectRatio ? image.aspectRatio : '?'))))), this.state.loaded === false && /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 514,
        columnNumber: 17
      }
    }), this.state.forbidden === true && this.state.description === IMAGETABLE_DESCRIPTIONS.legacy && /*#__PURE__*/React.createElement("div", {
      className: classes.centeredDiv,
      style: {
        padding: '10px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 517,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      align: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 518,
        columnNumber: 21
      }
    }, "Cannot display legacy images because your account is forbidden from viewing some objects in the response")), (this.state.images == null && this.state.existingImages == null || this.state.totalElements === 0 || this.state.morePages === false) && this.state.forbidden === false && /*#__PURE__*/React.createElement("div", {
      className: classes.centeredDiv,
      style: {
        padding: '10px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 522,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      align: "center",
      justify: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 523,
        columnNumber: 21
      }
    }, "There are no more ", this.state.description ? this.state.description : '', " images for this provider")), Pagination(this.state, this, classes, false));
  }
  static makeUri(provider, entityId, title, state) {
    let query = BASE_URIS.prefix + state.baseUri;
    if (entityId == null && (title == null || title === '')) {
      return null;
    }
    if (entityId != null && entityId !== '') {
      query += "?".concat(TPIS_PARAMS.ENTITY_ID, "=") + entityId + (provider != null && provider !== '' ? "&".concat(TPIS_PARAMS.PROVIDER, "=") + provider : '');
    } else if (title != null && title !== '') {
      query += "?".concat(TPIS_PARAMS.TITLE, "=") + encodeURIComponent(title);
    }
    query += "&".concat(TPIS_PARAMS.PAGE, "=") + state.page + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=") + state.pageSize + TPIS_PARAMS.INCLUDE_ASSOCIATIONS;
    if (state.description === IMAGETABLE_DESCRIPTIONS.published) {
      query += TPIS_PARAMS.PUBLISHED;
    } else if (state.description === IMAGETABLE_DESCRIPTIONS.auditPending) {
      query += TPIS_PARAMS.AUDIT_PENDING;
    } else if (state.description === IMAGETABLE_DESCRIPTIONS.accepted) {
      query += TPIS_PARAMS.AUDIT_ACCEPTED;
    } else if (state.description === IMAGETABLE_DESCRIPTIONS.rejected) {
      query += TPIS_PARAMS.AUDIT_REJECTED;
    } else if (state.description === IMAGETABLE_DESCRIPTIONS.publishPending) {
      query += TPIS_PARAMS.PUBLISH_PENDING;
    } else if (state.description === IMAGETABLE_DESCRIPTIONS.publishFailed) {
      query += TPIS_PARAMS.PUBLISH_FAILED;
    }
    return query;
  }
  static determineProviderAndEntityId(state) {
    let provider,
      entityId = null;
    let success = false;
    if (state.entityId != null && state.entityId !== '') {
      // If entityId and entityProvider are provided, obviously use them
      entityId = state.entityId;
      success = true;
    } else if (state.adiId != null && state.adiId !== '') {
      entityId = state.adiId;
      success = true;
    } else if (state.merlinId != null && state.merlinId !== '') {
      entityId = state.merlinId;
      success = true;
    }

    // We no longer need to provide provider
    return {
      provider,
      entityId,
      success
    };
  }
  audit(item, action, merlinId, adiId, self) {
    this.state.failures = null;
    let uri = "".concat(BASE_URIS.prefix).concat(BASE_URIS.audit) + "?".concat(TPIS_PARAMS.IMAGE_ID, "=") + item.id + "&".concat(TPIS_PARAMS.ACTION, "=") + action;
    let adiParams = "&".concat(TPIS_PARAMS.PROVIDER, "=") + ID_SPACE.ADI + "&".concat(TPIS_PARAMS.ENTITY_ID, "=") + adiId;
    let merlinParams = "&".concat(TPIS_PARAMS.PROVIDER, "=") + ID_SPACE.MERLIN + "&".concat(TPIS_PARAMS.ENTITY_ID, "=") + merlinId;
    let auditNotes = this.state.auditNotes[item.id];
    if (auditNotes != null && auditNotes !== '') {
      uri += "&".concat(TPIS_PARAMS.DESCRIPTION, "=") + auditNotes;
    }
    Util.fetchWithRedirect(
    // try adiParams first, since most users will upload with adiId
    uri + adiParams, 'POST', this.props).then(resp => {
      if (resp.status === 404 || resp.status === 400) {
        // no association was found with imageId and adiParams OR we didn't have an adiId to provide
        // try merlinParams
        Util.fetchWithRedirect(uri + merlinParams, 'POST', this.props).then(resp => {
          self.loadContent();
        }).catch(e => Util.log('ImageTable.audit', true, e, true));
      } else {
        self.loadContent();
      }
    }).catch(e => Util.log('ImageTable.audit', true, e, true));
  }
  publish(item, action, provider, entityId, self) {
    let uri = '/ws/api/publish' + '?imageId=' + item.id + '&action=' + action;
    // + '&entityProvider=' + provider
    // + '&entityId=' + entityId;

    Util.fetchWithRedirect(uri, 'POST', this.props).then(resp => {
      ImageTable.handlePubResponse(resp, self);
    }).catch(e => Util.log('ImageTable.publish', true, e, true));
  }
  delete(item, merlinId, adiId, entityId, self) {
    self.state.loaded = false;
    self.forceUpdate();
    let toDelete = null;
    if (entityId != null && entityId !== '') {
      toDelete = entityId;
    } else if (merlinId != null && merlinId !== '') {
      toDelete = merlinId;
    } else if (adiId != null && adiId !== '') {
      toDelete = adiId;
    }
    let uri = '/ws/api/update/image' + '?imageId=' + item.id + (toDelete != null ? '&entityId=' + toDelete : '');
    Util.fetchWithRedirect(uri + '&method=DELETE', 'POST', this.props).then(resp => {
      if (resp.status === 400) {
        if (resp.message === 'cannot perform operation on published images') {
          this.deleteFailure(self, resp);
        } else {
          // Can't delete image because it has other associations
          Util.fetchWithRedirect(uri + '&method=DELETE_ASSOCIATIONS', 'POST', this.props).then(resp => {
            if (![400, 401, 402, 403, 500].includes(resp.status)) {
              this.deleteSuccess('Association successfully deleted for this entity', self);
            } else {
              this.deleteFailure(self, resp);
            }
          }).catch(e => Util.log('ImageTable.delete', true, e, true));
        }
      } else {
        this.deleteSuccess('Image and association successfully deleted for this entity', self);
      }
    }).catch(e => Util.log('ImageTable.delete', true, e, true));
  }
  deleteSuccess(message, self) {
    Util.openSnackbar(message, self.snackbar);
    self.loadContent();
  }
  deleteFailure(self, resp) {
    let dialogText = "Could not delete image or association." + (resp.message != null && resp.message !== '' ? " Message from server: " + resp.message : '');
    Util.createDialog("Delete failed", dialogText, self.dialogRef);
    self.state.loaded = true;
    self.forceUpdate();
  }
  static handlePubResponse(publishResponse, self) {
    if (publishResponse.status == null) {
      return;
    }
    const _publishResponse$stat = publishResponse.status,
      associations = _publishResponse$stat.associations,
      images = _publishResponse$stat.images;
    const failures = [];
    if (associations != null && associations.length > 0) {
      for (let assoc of associations) {
        if (assoc.publishStatus === PUBLISH_STATUS.failed) {
          failures.push({
            'type': 'association',
            'entityId': assoc.entityId,
            'imageId': assoc.imageId,
            'reason': assoc.publishDescription
          });
        }
      }
    }
    if (images != null && images.length > 0) {
      for (let image of images) {
        if (image.publishStatus === PUBLISH_STATUS.failed) {
          failures.push({
            'type': 'image',
            'imageId': image.id,
            'reason': image.publishDescription
          });
        }
      }
    }
    self.state.failures = failures;
    self.loadContent();
  }
  /**
   * Creates a tooltip containing all the information regarding association failures or pending publishes, including failure reasons
   */
  static displayAnyAssociationPublishIssues(image, classes) {
    const associations = image.associations;
    if (associations == null) {
      return null;
    }
    let publishPendingAssociations = 0;
    let publishFailedAssociations = 0;
    const failureReasons = [];
    for (let assoc of associations) {
      if (assoc.publishStatus != null && assoc.publishStatus !== '') {
        if (PUBLISH_STATUS.pending === assoc.publishStatus.toUpperCase()) {
          publishPendingAssociations++;
        } else if (PUBLISH_STATUS.failed === assoc.publishStatus.toUpperCase()) {
          publishFailedAssociations++;
          if (assoc.publishDescription != null) {
            failureReasons.push(assoc.publishDescription);
          }
        }
      }
    }
    if (publishFailedAssociations === 0 && publishPendingAssociations === 0) {
      return null;
    }
    let tooltipTitle = "There are ";
    if (publishFailedAssociations > 0) {
      tooltipTitle += publishFailedAssociations + " associations that have FAILED to publish";
      if (failureReasons.length > 0) {
        tooltipTitle += ". Message(s) from server: ";
        for (let _ref of failureReasons.entries()) {
          var _ref2 = _slicedToArray(_ref, 2);
          let index = _ref2[0];
          let fail = _ref2[1];
          tooltipTitle += '"' + fail + '"';
          if (index === failureReasons.length - 1) {
            tooltipTitle += '. ';
          } else {
            tooltipTitle += ', ';
          }
        }
      }
    }
    if (publishPendingAssociations > 0) {
      if (publishFailedAssociations > 0) {
        tooltipTitle += " and ";
      }
      tooltipTitle += publishPendingAssociations + " associations that are still PENDING publish";
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltipTitle,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 780,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Error, {
      className: classes.dqBadge,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 781,
        columnNumber: 17
      }
    }));
  }
  static displayAnyAssociationAuditIssues(image, classes) {
    const associations = image.associations;
    if (associations == null) {
      return null;
    }
    let auditPendingAssociations = 0;
    let auditRejectedAssociations = 0;
    for (let assoc of associations) {
      if (assoc.auditStatus != null && assoc.auditStatus !== '') {
        if (AUDIT_STATUS.pending === assoc.auditStatus.toUpperCase()) {
          auditPendingAssociations++;
        } else if (AUDIT_STATUS.rejected === assoc.auditStatus.toUpperCase()) {
          auditRejectedAssociations++;
        }
      }
    }
    if (auditRejectedAssociations === 0 && auditPendingAssociations === 0) {
      return null;
    }
    let tooltipTitle = "There are ";
    if (auditRejectedAssociations > 0) {
      tooltipTitle += auditRejectedAssociations + " associations that have been audited and REJECTED";
    }
    if (auditPendingAssociations > 0) {
      if (auditRejectedAssociations > 0) {
        tooltipTitle += " and ";
      }
      tooltipTitle += auditPendingAssociations + " associations that are still PENDING audit";
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltipTitle,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 823,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Error, {
      className: classes.dqBadge,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 824,
        columnNumber: 17
      }
    }));
  }
  static displayAnyDataQualityIssues(image, classes) {
    const associations = image.associations;
    if (associations == null) {
      return null;
    }
    let updatedAssocs = 0;
    let deletedAssocs = 0;
    for (let assoc of associations) {
      if (assoc.dataQualityStatus != null && assoc.dataQualityStatus !== '') {
        if (DATA_QUALITY_STATUS.DELETED === assoc.dataQualityStatus.toUpperCase()) {
          deletedAssocs++;
        } else if (DATA_QUALITY_STATUS.UPDATED === assoc.dataQualityStatus.toUpperCase()) {
          updatedAssocs++;
        }
      }
    }
    if (updatedAssocs === 0 && deletedAssocs === 0) {
      return null;
    }
    let tooltipTitle = "There are ";
    if (updatedAssocs > 0) {
      tooltipTitle += updatedAssocs + " associations that were updated outside of TPIC";
    }
    if (deletedAssocs > 0) {
      if (updatedAssocs > 0) {
        tooltipTitle += " and ";
      }
      tooltipTitle += deletedAssocs + " associations that were deleted outside of TPIC";
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltipTitle,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 866,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Error, {
      className: classes.dqBadge,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 867,
        columnNumber: 17
      }
    }));
  }
  static imageHasPublishPendingOrFailedAssociations(image) {
    const associations = image.associations;
    if (associations == null) {
      return false;
    }
    for (let assoc of associations) {
      if (assoc.publishStatus != null && assoc.publishStatus !== '') {
        if (PUBLISH_STATUS.failed === assoc.publishStatus.toUpperCase() || PUBLISH_STATUS.pending === assoc.publishStatus.toUpperCase()) {
          return true;
        }
      }
    }
  }
  static imageHasAuditableAssociations(image) {
    // return false if it has NO associations
    if (image == null || image.associations == null) {
      return false;
    }

    // return true if it has ANY associations that aren't published
    for (let assoc of image.associations) {
      if (assoc.publishStatus !== PUBLISH_STATUS.published) {
        return true;
      }
    }
    return false;
  }
}
export default withStyles(styles)(withRouter(ImageTable));